import { jsx, type JsxElementProps } from '@amazon/vinyl-tsx'
import { data } from '@amazon/vinyl-observable'
import { getString } from '@/components/i18n/bundle.generated'

export class LoadingController {
    private loadingCount = data(0)

    readonly loading = this.loadingCount.map((value) => value > 0)

    /**
     * Shows the loading indicator, returning a function that when called indicates that
     * the loading has finished.
     * Multiple loads can be simultaneous.
     * The returned done function must be called.
     */
    show(): () => void {
        let doneCalled = false
        this.loadingCount.value++
        return () => {
            if (doneCalled) return
            doneCalled = true
            this.loadingCount.value--
        }
    }
}

export function LoadingIndicator(props: JsxElementProps<'div'>) {
    return (
        <div
            className="loader"
            role="progressbar"
            aria-label={getString('dmusic_loading_spinner_accessibility_label')}
            {...props}
        />
    )
}
